export default {"src":"/_next/static/media/autollecom.64b564c4.svg","height":16,"width":21,"blurWidth":0,"blurHeight":0};